export default {
  laptopRenewalInfo:
    "When your laptop is eligible for replacement, Global IT Services will contact you directly to schedule your renewal.",
};
